export default __webpack_public_path__ + "static/media/Ring of Conservation.86282427.jpg";